// extracted by mini-css-extract-plugin
module.exports = {"statusHeadline":"StatusExplainer_statusHeadline__7x_T3","statusExplainer":"StatusExplainer_statusExplainer__2zAKF"};